module.exports = __webpack_public_path__ + "static/img/rank1.5c47138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank/rank1.png
// module id = PDm8
// module chunks = 1